

export class VehicleTypeAlertOutput implements IVehicleTypeAlertOutput {
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id!: number;

    constructor(data?: IVehicleTypeAlertOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_type_id = _data["vehicle_type_id"];
        }
    }

    static fromJS(data: any): VehicleTypeAlertOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeAlertOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_type_id"] = this.vehicle_type_id;
        return data; 
    }
}

export interface IVehicleTypeAlertOutput {
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id: number;
}

